import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetSeasonsUseCase {
    execute(bySeriesId: string, byCustomValue: string): Promise<any>;
}

export class GetSeasonsUseCase implements IGetSeasonsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(bySeriesId: string, byCustomValue: string): Promise<any> {
        return this.mpxRepository.getSeasons(bySeriesId, byCustomValue);
    }
}
